import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@fortem-monorepo/react-ui'

export const CorrectionReviewTable = ({ rows }: { rows: [string, React.ReactNode, React.ReactNode][] }) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>Field</TableHead>
        <TableHead>Current</TableHead>
        <TableHead>Proposed</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {rows.map(([label, current, proposed]) => (
        <TableRow key={label}>
          <TableCell>{label}</TableCell>
          <TableCell>{current ?? '—'}</TableCell>
          <TableCell>{proposed ?? '—'}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
)
